import React, { useState, useCallback } from "react";
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";
import { imageList } from "../config/imageData";

const PAINT_ALL_IMAGES = imageList.filter(img =>
  img.path.includes("Background Paint") // 只取 Background PAINT 下的图片
);
// 🌟 核心修改：把「全部」改成「All」，如需隐藏直接删除这一行即可
const CATEGORY_DATA = {
  "All":PAINT_ALL_IMAGES, // 替换「全部」为「All」
  "200Wolf": imageList.filter(img =>
    img.path.includes("200Wolf")
  ),
  "Bocchi's room": imageList.filter(img =>
    img.path.includes("Bocchi's room")
  ),
  "Helluva Boss": imageList.filter(img =>
    img.path.includes("Helluva Boss")
  )
};

export default function BgPaintImage() {
  // 状态默认选中 All（如果隐藏All则默认选中第一个分类）
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState("All"); // 对应修改为All
  const [photos, setPhotos] = useState(CATEGORY_DATA["All"]); // 对应修改为All

  // 分类切换函数
  const changeCategory = (category) => {
    setActiveCategory(category);
    setPhotos(CATEGORY_DATA[category] || imageList);
  };

  // 图片预览
  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  // 样式（保持和你页面一致）
  const containerStyle = {
    width: "100%",
    padding: "0 20px",
    boxSizing: "border-box",
    marginTop: "20px"
  };

  const btnStyle = {
    padding: "8px 16px",
    margin: "0 8px 15px 0",
    border: "none",
    borderRadius: "4px",
    backgroundColor: "#f0f0f0",
    cursor: "pointer",
    fontSize: "14px",
    fontFamily: "华文细黑"
  };

  const activeBtnStyle = {
    ...btnStyle,
    backgroundColor: "#333",
    color: "white"
  };

  return (
    <div style={containerStyle}>
      {/* 分类按钮（显示All，样式不变） */}
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        {Object.keys(CATEGORY_DATA).map((category) => (
          <button
            key={category}
            style={activeCategory === category ? activeBtnStyle : btnStyle}
            onClick={() => changeCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>

      {/* 图片画廊 */}
      {photos.length > 0 ? (
        <Gallery
          photos={photos}
          onClick={openLightbox}
          columns={({ width }) => {
            if (width < 768) return 1;
            if (width < 1366) return 2;
            return 3;
          }}
          margin={10}
        />
      ) : (
        <div style={{ textAlign: "center", padding: "50px", fontFamily: "华文细黑" }}>
          No images in this category
        </div>
      )}

      {/* 预览弹窗 */}
      <ModalGateway>
        {viewerIsOpen ? (
          <Modal onClose={closeLightbox}>
            <Carousel
              currentIndex={currentImage}
              views={photos.map(x => ({
                src: x.src,
                width: x.width,
                height: x.height,
                caption: x.title
              }))}
            />
          </Modal>
        ) : null}
      </ModalGateway>
    </div>
  );
}